<template>
	<el-dialog
		title="批量关联厂家直采"
		:visible.sync="visible"
		width="90%"
		top="25px"
		append-to-body
		custom-class="batch-alibaba-connect-dialog"
		:close-on-click-modal="false"
		@closed="onDialogClosed"
	>
		<div class="batch-connect-body">
			<div class="batch-connect-left">
				<p class="side-title">已选订单已按商品规格分组</p>
				<div class="sku-scroll auto_scrollbar">
					<div
						v-for="(row, idx) in skuItems"
						:key="row._batchKey"
						class="sku-card"
						:class="{ active: idx === activeIndex }"
						@click="selectSku(idx)"
					>
						<div class="sku-card-img">
							<img v-if="row.product_pic" :src="row.product_pic" alt="" />
						</div>
						<div class="sku-card-main">
							<p class="sku-name">{{ row.product_name || '—' }}</p>
							<p class="sku-spec">规格：{{ row.spec_value || '—' }}</p>
							<p class="sku-meta">规格ID：{{ row.wx_sku_id || '—' }}</p>
							<p class="sku-meta">商品ID：{{ row.wx_product_id || '—' }}</p>
							<p class="sku-meta" v-if="row.shop_name">店铺：{{ row.shop_name }}</p>
							<p class="sku-meta">含 {{ (row.batch_order_product_ids || []).length }} 笔订单行</p>
							<p class="sku-link-row">
								<span
									class="sku-link-tag"
									:class="isAlibabaLinked(row) ? 'is-linked' : 'is-pending'"
								>{{ isAlibabaLinked(row) ? '已关联' : '待关联' }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="batch-connect-right">
				<connect-box
					ref="goodsConnect"
					:hide-goods-info="true"
					@saved="onConnectSaved"
					@close="onConnectBoxClose"
				/>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import connectBox from '../alibaba_goods_connect/connect_box.vue'

export default {
	name: 'WxBatchAlibabaConnect',
	components: { connectBox },
	data() {
		return {
			visible: false,
			skuItems: [],
			activeIndex: 0,
		}
	},
	methods: {
		isAlibabaLinked(row) {
			return !!row && !!row.is_relative
		},
		/**
		 * @param {Array<{
		 *   _batchKey:string, shop_id:string, shop_name?:string,
		 *   wx_product_id:string|number, wx_sku_id:string|number,
		 *   order_product_id:number, batch_order_product_ids:number[],
		 *   product_name?:string, product_pic?:string, spec_value?:string,
		 *   is_relative?:boolean, source_sku_id?:string
		 * }>} rows
		 */
		open(rows) {
			this.skuItems = Array.isArray(rows) ? rows.map(this.normalizeRow) : []
			this.activeIndex = 0
			this.visible = true
			this.$nextTick(() => this.loadActiveConnect())
		},
		normalizeRow(row) {
			const shopId = String(row.shop_id || '')
			const skuId = row.wx_sku_id != null && row.wx_sku_id !== ''
				? String(row.wx_sku_id)
				: `id_${row.order_product_id || row.id}`
			const batchIds = Array.isArray(row.batch_order_product_ids)
				? row.batch_order_product_ids.map(Number).filter(id => id > 0)
				: [Number(row.order_product_id || row.id)].filter(id => id > 0)
			return {
				...row,
				shop_id: shopId,
				wx_sku_id: row.wx_sku_id,
				wx_product_id: row.wx_product_id,
				order_product_id: Number(row.order_product_id || row.id || 0),
				batch_order_product_ids: batchIds,
				_batchKey: row._batchKey || `${shopId}_${skuId}`,
			}
		},
		selectSku(index) {
			if (index === this.activeIndex || index < 0 || index >= this.skuItems.length) return
			this.activeIndex = index
			this.loadActiveConnect()
		},
		loadActiveConnect() {
			const row = this.skuItems[this.activeIndex]
			if (!row || !this.$refs.goodsConnect) return
			if (!row.wx_product_id) {
				this.$message.error('微信商品不存在')
				return
			}
			this.$refs.goodsConnect.clean()
			this.$nextTick(() => {
				this.$refs.goodsConnect.init({
					order_product_id: row.order_product_id,
					shop_id: row.shop_id || '',
					wx_product_id: row.wx_product_id,
					wx_sku_id: row.wx_sku_id,
					batch_order_product_ids: row.batch_order_product_ids || [],
					alibaba_sku_id: row.source_sku_id || '',
				})
			})
		},
		onConnectSaved() {
			this.$emit('refresh')
		},
		onConnectBoxClose() {
			this.$emit('refresh')
		},
		/** 列表刷新后按 order_product_id 合并关联状态 */
		syncSkuItemsFromList(orderList) {
			if (!Array.isArray(orderList) || !this.skuItems.length) return
			const productById = new Map()
			orderList.forEach((order) => {
				;(order.products || []).forEach((p) => {
					if (p && p.id) productById.set(Number(p.id), { ...p, shop_id: order.shop_id, shop_name: order.shop_name })
				})
			})
			this.skuItems = this.skuItems.map((row) => {
				const ids = row.batch_order_product_ids || [row.order_product_id]
				let linked = false
				let sourceSku = row.source_sku_id || ''
				ids.forEach((id) => {
					const fresh = productById.get(Number(id))
					if (!fresh) return
					if (fresh.is_relative) linked = true
					if (fresh.source_sku_id) sourceSku = fresh.source_sku_id
				})
				const primary = productById.get(Number(row.order_product_id))
				return this.normalizeRow({
					...row,
					is_relative: linked || !!(primary && primary.is_relative),
					source_sku_id: sourceSku || (primary && primary.source_sku_id) || '',
					product_name: (primary && primary.title) || row.product_name,
					product_pic: (primary && primary.thumb_img) || row.product_pic,
				})
			})
			this.$nextTick(() => this.loadActiveConnect())
		},
		onDialogClosed() {
			this.skuItems = []
			this.activeIndex = 0
			if (this.$refs.goodsConnect) {
				this.$refs.goodsConnect.clean()
			}
		},
	},
}
</script>

<style scoped>
.batch-connect-body {
	display: flex;
	gap: 16px;
	min-height: 72vh;
	max-height: calc(100vh - 120px);
	box-sizing: border-box;
}
.batch-connect-left {
	width: 320px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	border: 1px solid #eee;
	border-radius: 6px;
	overflow: hidden;
	background: #fafafa;
}
.side-title {
	margin: 0;
	padding: 12px 14px;
	font-size: 13px;
	color: #666;
	background: #f0f0f0;
	border-bottom: 1px solid #eee;
}
.sku-scroll {
	flex: 1;
	overflow-y: auto;
	padding: 8px;
}
.sku-card {
	display: flex;
	gap: 10px;
	padding: 10px;
	margin-bottom: 8px;
	background: #fff;
	border: 1px solid #e8e8e8;
	border-radius: 6px;
	cursor: pointer;
	transition: border-color 0.15s, box-shadow 0.15s;
}
.sku-card:hover {
	border-color: #ccc;
}
.sku-card.active {
	border-color: #f0423f;
	box-shadow: 0 0 0 1px rgba(240, 66, 63, 0.15);
}
.sku-card-img {
	width: 56px;
	height: 56px;
	flex-shrink: 0;
	border-radius: 4px;
	overflow: hidden;
	background: #eee;
}
.sku-card-img img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.sku-card-main {
	flex: 1;
	min-width: 0;
	font-size: 12px;
	line-height: 1.45;
}
.sku-link-row {
	margin: 4px 0 0;
}
.sku-link-tag {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 11px;
	line-height: 1.4;
}
.sku-link-tag.is-linked {
	color: #529b2e;
	background: #f0f9eb;
	border: 1px solid #c2e7b0;
}
.sku-link-tag.is-pending {
	color: #c45656;
	background: #fef0f0;
	border: 1px solid #fbc4c4;
}
.sku-name {
	margin: 0 0 4px;
	color: #333;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.sku-spec,
.sku-meta {
	margin: 0 0 2px;
	color: #888;
	word-break: break-all;
}
.batch-connect-right {
	flex: 1;
	min-width: 0;
	overflow: auto;
	border: 1px solid #eee;
	border-radius: 6px;
	padding: 8px 0;
	background: #fff;
}
</style>

<style>
.batch-alibaba-connect-dialog {
	box-sizing: border-box;
}
.batch-alibaba-connect-dialog .el-dialog__header {
	padding: 14px 20px;
	border-bottom: 1px solid #eee;
}
.batch-alibaba-connect-dialog .el-dialog__body {
	padding: 12px 16px 16px;
	max-height: calc(100vh - 54px);
	overflow: hidden;
	box-sizing: border-box;
}
</style>
